// Twitter Bootstrap modal
// import 'bootstrap/js/dist/modal';
import mixitup from 'mixitup';
import Player from '@vimeo/player';

var objectFitImages = require('object-fit-images');

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Starter = {
		// All pages
		'common': {
			init: function() {
				objectFitImages();

				let mode = '';
				function assign_bootstrap_mode() {
					let width = $( window ).width();

					if (width<576) {
						mode = "mode-xs";
					}
					else if (width>1200) {
						mode = "mode-xl";
					}
					else if (width>992) {
						mode = "mode-lg";
					}
					else if (width>768) {
						mode = "mode-md";
					}
					else if (width>576) {
						mode = "mode-sm";
					}
					$("body").removeClass("mode-xs").removeClass("mode-sm").removeClass("mode-md").removeClass("mode-lg").removeClass("mode-xl").addClass(mode);
				}
				assign_bootstrap_mode();

				$(window).on('resize', function() {
					assign_bootstrap_mode();
				});

				$('.statusbar .statusbar__currentfilter').on('click', function(){
					$('.statusbar').toggleClass('statusbar--active');
				});

				if($('.artists').length){
					let hashedValue = window.location.hash;
					if (hashedValue.replace('#', '') == '') {
						hashedValue = 'all';
					} else {
						hashedValue = '.' + hashedValue.replace('#', '');
						let text = $('.statusbar__filter').find('[data-filter="' + hashedValue + '"]').text();
						$('.statusbar__currentfilter').text(text);
						$('.statusbar').removeClass('statusbar--active');
						$('.footer--fixed').addClass('footer--slideout');
					}
					const mixer = mixitup('.artists', {
						load: {
							filter: hashedValue
						},
						callbacks: {
							onMixClick: function (event) {
								let text = $(this).text();
								$('.statusbar__currentfilter').text(text);
								$('.statusbar').removeClass('statusbar--active');
								$('.footer--fixed').addClass('footer--slideout');
							}
						}
					});
					revealArtists();

				}

				let loop = 2;
				function hideArtist(){
					var hide = setInterval(function () {
						let $revealedArtist = $('.artists .artist--reveal').first();
						if ($revealedArtist.length){
							$revealedArtist.removeClass('artist--reveal');
						} else {
							if(loop % 2 == 0){
								clearInterval(hide);
								revealArtists('reverse');
							} else {
								clearInterval(hide);
								revealArtists();
							}
							loop++;
						}
					}, 1200);
				}

				if($('#fullpage').length){

					$('.section .js-next').on('click', function(){
						const nextSection = $(this).closest('.section').next('.section');
						$('#fullpage').scrollTop(nextSection[0].offsetTop);
					});

					$('.js-totop').on('click', function(){
						$('#fullpage').scrollTop(0);
					});
				}


				$(window).on('scroll',function(e) {
					footerShow();
				});

				function footerShow(){
					var top = window.pageYOffset || document.documentElement.scrollTo;
					if(typeof top !== 'number'){
						//Grote footer tonen
						$('.footer--fixed').removeClass('footer--slideout');
					} else {
						//Grote footer relative en andere fixed footer tonen
						$('.footer--fixed').addClass('footer--slideout');
					}
				}

				$('header .menu, header .icon-close').on('click', function(){
					$('.programs').toggleClass('programs--active');
				});

				function revealArtists(direction){
					let counter = 1;
					let row = 1;
					let globalcounter = 0;
					let delay = 250;

					if(direction){
						row = 2;
					}
					$('.artists .artist').each(function(index, value){
						if(mode == 'mode-xl'){
							if (row % 2 == 0){
								//console.log('Even row');
								if(counter % 2 == 0){

									setTimeout(() => {
										$(this).addClass('artist--reveal');
									}, delay * globalcounter);

									globalcounter++;
								}
							} else {
								//console.log('Odd row');
								if(counter % 2 !== 0){
									setTimeout(() => {
										$(this).addClass('artist--reveal');
									}, delay * globalcounter);
									globalcounter++;

								}
							}
							if(counter % 4 == 0){
								//console.log('New row');
								counter = 0;
								row = row + 1;
							}
						} else if (mode == 'mode-lg'){
							if (row % 2 == 0){
								//console.log('Even row');
								if(counter % 2 == 0){
									setTimeout(() => {
										$(this).addClass('artist--reveal');
									}, delay * globalcounter);
									globalcounter++;
								}
							} else {
								//console.log('Odd row');
								if(counter == 1 || counter == 3){
									setTimeout(() => {
										$(this).addClass('artist--reveal');
									}, delay * globalcounter);
									globalcounter++;
								}
							}
							if(counter % 3 == 0){
								counter = 0;
								row = row + 1;
							}
						} else if (mode == 'mode-md'){
							if (row % 2 == 0){
								//console.log('Even row');
								if(counter == 2){
									setTimeout(() => {
										$(this).addClass('artist--reveal');
									}, delay * globalcounter);
									globalcounter++;
								}
							} else {
								//console.log('Odd row');
								if(counter == 1){
									setTimeout(() => {
										$(this).addClass('artist--reveal');
									}, delay * globalcounter);
									globalcounter++;
								}
							}
							if(counter % 2 == 0){
								//console.log('New row');
								counter = 0;
								row = row + 1;
							}
						} else if(mode == 'mode-xs'){
							if(counter == 2){
								setTimeout(() => {
									$(this).addClass('artist--reveal');
								}, delay * globalcounter);
								globalcounter++;
							}
							if(counter % 2 == 0){
								counter = 0;
							}
						}
						counter++;

						let length = $('.artists .artist').length - 1;
						if (length == index){
							setTimeout(() => {
								hideArtist();
							}, globalcounter * delay);
						}
					});
				}

			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Starter;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

  	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
